export const BODY_BACKGROUND_COLOR: string =
  'var(--chakra-colors-chakra-body-bg)';
